import { useToggle } from "@artists/devkit"
import { useCallback, useState } from "react"

import { useAuth } from "../../../../api"

export const useUnregisteredUserPrompt = () => {
	const { authorized } = useAuth()
	const [isAuthWarningShown, setIsAuthWarningShown] = useState(false)
	const [isOpen, open, close] = useToggle()
	const [callBack, setCallback] = useState<(() => void) | null>(null)

	const onUserAction = useCallback(
		(callback: (() => void) | null) => {
			if (!authorized && !isAuthWarningShown) {
				setIsAuthWarningShown(true)
				setCallback(() => callback)
				open()

				return false
			}

			return true
		},
		[authorized, isAuthWarningShown, open],
	)

	const onClose = () => {
		close()
		callBack?.()
	}

	return {
		isOpen,
		onUserAction,
		onClose,
		callBack,
	}
}
